function UpdateButton({ onClick }) {
  return (
    <button onClick={onClick} className="fas fa-pen mr-2 text-sm  bg-yellow-500 text-white  active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">
      {" "}
    </button>
  );
}
export default UpdateButton;
